import { SVGProps, Ref, forwardRef } from 'react';

export const PenSquareOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.944 1.11 4.83 8.223v2.944h2.944l7.113-7.114a2.081 2.081 0 1 0-2.943-2.943m1.376 2.53-.963-.963.577-.577a.681.681 0 0 1 .963.963zm-1.953.027L6.23 8.803v.964h.964L12.33 4.63z"
                    fill="currentColor"
                />
                <path
                    d="M.5 8.837c0-5.663.785-6.614 6.167-6.665v1.4c-1.19.012-2.073.069-2.744.195-.747.141-1.092.344-1.287.539s-.398.54-.539 1.287C1.954 6.355 1.9 7.39 1.9 8.837c0 1.447.054 2.482.197 3.243.141.748.344 1.093.539 1.288.195.194.54.397 1.287.538.762.144 1.796.197 3.244.197 1.447 0 2.482-.053 3.243-.197.748-.14 1.093-.344 1.287-.538.195-.195.398-.54.54-1.288.126-.671.182-1.555.194-2.746h1.4c-.05 5.384-1 6.17-6.664 6.17C1.333 15.503.5 14.67.5 8.836"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
PenSquareOutlinedSize16Glyph.displayName = 'PenSquareOutlinedSize16Glyph';
